import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GerenciadorPrecos } from '../../../../@types/GerenciadorPrecos';
import { Sort, SortPriceType } from '../../../../@types/sort';
import { RESET_GERENCIADOR_DATAKEY, selectorGerenciadorDatakeys, UPDATE_GERENCIADOR_DATAKEY } from '../../../../reducers';
import { initialState, selectorSort, SET_GERENCIADOR_SORT } from '../../../../reducers/gerenciadorPrecos/sort';
import { GerenciadorSortOption, getSortOptionValue, sortOptionsColumnMap } from '../sortOptions';

const useGerenciadorSort = () => {
  const dispatch = useDispatch();

  const datakeys = useSelector(selectorGerenciadorDatakeys);

  const sort = useSelector(selectorSort);

  const handleUpdateDataKeys = useCallback(
    (column: string, value: GerenciadorPrecos.DataKey) => {
      const newColumn = sortOptionsColumnMap[column] || column;
      const newDataKey = { [newColumn]: value };
      dispatch(RESET_GERENCIADOR_DATAKEY());
      dispatch(UPDATE_GERENCIADOR_DATAKEY(newDataKey));
    },
    [dispatch],
  );

  const onSortColumn = useCallback(
    (type: GerenciadorPrecos.DataKey, orderBy: Sort['orderBy'], priceType?: SortPriceType) => {
      const newSort = {
        type,
        orderBy,
        priceType: priceType ?? (sort.type === type ? sort.priceType : 'REGULAR'),
      };
      dispatch(SET_GERENCIADOR_SORT(newSort));
    },
    [dispatch, sort.priceType, sort.type],
  );

  const onUpdateSortColumn = useCallback(
    (column: string, value: GerenciadorPrecos.DataKey, option?: GerenciadorSortOption) => {
      const priceType = option?.priceType ?? 'REGULAR';
      const sortValue = option?.sortValue || value;
      const isSameColumn = sort.type === sortValue && sort.priceType === priceType;
      const newOrderBy = isSameColumn ? (sort.orderBy === 'asc' ? 'desc' : 'asc') : 'asc';

      onSortColumn(sortValue, newOrderBy, priceType);
      handleUpdateDataKeys(column, sortValue);
    },
    [sort.type, sort.priceType, sort.orderBy, onSortColumn, handleUpdateDataKeys],
  );

  return {
    datakeys,
    sort,
    sortPriceType: sort.priceType,
    initialState,
    onSortColumn,
    onUpdateSortColumn,
    getSelectedSortOptionValue: getSortOptionValue,
  } as const;
};

export default useGerenciadorSort;
